<div class="mobile-toolbar-container">
  <div class="toolbar-bar">
    <button mat-button class="bar-button" (click)="navigateToHome()"
      [attr.aria-label]="'layout.mobile.toolbar.home' | translate">
      <app-icon icon="solar:home-2-bold-duotone" customClass="d-flex" color="#4CAF50" size="28"></app-icon>
    </button>

    <button mat-button class="bar-button assistant-bar-button" (click)="onChatClick()"
      [attr.aria-label]="'layout.mobile.toolbar.assistant' | translate" data-tour="mobile-ai-button">
      <app-icon icon="hugeicons:ai-voice" customClass="d-flex" color="#4CAF50" size="32"></app-icon>
    </button>

    <button mat-button class="bar-button" (click)="onAppsMenuClick()"
      [attr.aria-label]="'layout.mobile.toolbar.apps' | translate">
      <app-icon icon="solar:widget-3-line-duotone" customClass="d-flex" color="#4CAF50" size="28"></app-icon>
    </button>
  </div>
</div>
